export type ParsedAdGraphNode = {
  kind: string;
  label: string;
  id: string;
  isCrownJewel?: boolean;
  isOwned?: boolean;
};

export type ParsedAdGraphEdge = {
  sourceId: string;
  relationshipType: string;
  targetId: string;
  isAbusable?: boolean;
};

export type ParsedAdGraphOutput = {
  mode?: string;
  nodeCount: number;
  totalCount?: number;
  truncated: boolean;
  nodes: ParsedAdGraphNode[];
  edgeCount: number;
  edges: ParsedAdGraphEdge[];
};

const NODE_LINE_PATTERN = /^-\s+\[([^\]]+)\]\s+(.+?)\s+\(id:\s+(.+?)\)$/;
const EDGE_LINE_PATTERN = /^-\s+(\S+)\s+-\[([^\]]+)\]->\s+(\S+)$/;

export function parseAdGraphOutput(output: string): ParsedAdGraphOutput | null {
  const lines = output.split('\n').map((line) => line.trim());
  let mode: string | undefined;
  let nodeCount = 0;
  let totalCount: number | undefined;
  let truncated = false;
  let edgeCount = 0;
  let inEdgesSection = false;
  const nodes: ParsedAdGraphNode[] = [];
  const edges: ParsedAdGraphEdge[] = [];

  for (const line of lines) {
    if (line.startsWith('Graph mode:')) {
      mode = line.replace('Graph mode:', '').trim();
      continue;
    }

    const nodesHeader = line.match(
      /^Nodes:\s+(\d+)\s+returned\s+\((\d+)\s+total\)(.*)$/i,
    );
    if (nodesHeader) {
      nodeCount = Number(nodesHeader[1]);
      totalCount = Number(nodesHeader[2]);
      truncated = nodesHeader[3]?.includes('TRUNCATED') ?? false;
      inEdgesSection = false;
      continue;
    }

    if (line.startsWith('Edges:')) {
      edgeCount = Number(line.replace('Edges:', '').trim()) || 0;
      inEdgesSection = true;
      continue;
    }

    const nodeMatch = line.match(NODE_LINE_PATTERN);
    if (nodeMatch && !inEdgesSection) {
      nodes.push({
        kind: nodeMatch[1],
        label: nodeMatch[2].trim(),
        id: nodeMatch[3].trim(),
      });
      continue;
    }

    const edgeMatch = line.match(EDGE_LINE_PATTERN);
    if (edgeMatch) {
      edges.push({
        sourceId: edgeMatch[1],
        relationshipType: edgeMatch[2],
        targetId: edgeMatch[3],
      });
    }
  }

  if (nodes.length === 0 && edges.length === 0 && !mode) {
    return null;
  }

  return {
    mode,
    nodeCount: nodeCount || nodes.length,
    totalCount,
    truncated,
    nodes,
    edgeCount: edgeCount || edges.length,
    edges,
  };
}
